// extracted by mini-css-extract-plugin
module.exports = {"footer":"event-card-footer_footer__JNflw","footerContent":"event-card-footer_footerContent__0IHh5"};